import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;

// TODO: get all users``
export function changePassword({ password, confirmPassword, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`change-password`, {
        password,
        confirmPassword,
      });
      enqueueSnackbar("password is changed successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
